class UserSpaceConversationLabels {

  constructor(currentUserBasePath, apiClient) {

    this.basePath = `${currentUserBasePath}/helpdesk/user-space-conversation-labels`;
    this.apiClient = apiClient;

  }

  async createUserSpaceConversationLabel(label) {

    const path = this.basePath;

    return this.apiClient.post(path, {}, {}, label);

  }

  async getUserSpaceConversationLabelsByQueryOptions(queryOptions = {}) {

    const path = this.basePath;

    return this.apiClient.get(path, {}, queryOptions);

  }

  async updateUserSpaceConversationLabelById(conversationLabelId, label) {

    const path = `${this.basePath}/:conversationLabelId`;

    return this.apiClient.put(path, { conversationLabelId }, {}, label);

  }

  async deleteUserSpaceConversationLabelById(conversationLabelId) {

    const path = `${this.basePath}/:conversationLabelId`;

    return this.apiClient.delete(path, { conversationLabelId }, {});

  }

}

export default UserSpaceConversationLabels;